module.exports = __webpack_public_path__ + "img/yiqi.760b9fde.png";